'use client';
import { ServiceList1Type } from '@/types/global';

interface Props {
    serviceList: ServiceList1Type[];
    title: string;
    description: string;
}

const ServicesList = ({ serviceList, title, description }: Props) => {
    return (
        <section
            className={`desilo-service4-section overflow-hidden section-padding-top-bottom`}
            id="service-section"
        >
            <div className="container custom-container service">
                <div className="row gx-4 gy-5">
                    <div className="col-md-10">
                        {/*col-lg-8 col-xxl-6*/}
                        <div className="desilo__header row-padding-bottom text-left text-md-start">
                            <h2 className="title">
                                {title}
                            </h2>
                            <p className="hero2-content-text">
                                {description && description}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {/* service card start */}
                        {serviceList.map((item, i) => (
                            <div
                                key={i}
                                className="desilo-service-box4 fade-anim"
                            >
                                <h3 className="service-title order-0">{item.title}</h3>
                                <div className="service-info order-1">
                                    <p>{item.description}</p>
                                </div>
                                <div className="blog-item order-2">
                                    <div className="blog-tags mt-0">
                                        <ul className="custom-ul justify-content-start justify-content-lg-end">
                                            {item.tags.map((tag: string, index: number) => (
                                                <li key={index}>
                                                    <span className="service-tags">{tag}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {/* service card end */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServicesList;
